import HeroSection from "./Hero Section/HeroSection";

import TransactionFeatures from "./transactionFeatures/TransactionFeatures";
import CtaSection from "./CtaSection/CtaSection";
import SmartSolutionsSection from "./SmartSolution/SmartSolutionSection";

const Home = () => {
  return (
    <>
      <HeroSection />
      <div className="mt-24 lg:mt-32">
        <TransactionFeatures />
      </div>
      <SmartSolutionsSection />
      <CtaSection />
    </>
  );
};

export default Home;
